import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchExportGridService = (access_token, userId) =>
  axios.get(`${api}/Export/GetExportGrid?userId=${userId}`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const createExportService = (access_token, data) =>
  axios.post(`${api}/Export/CreateExport`, data, {
    headers: { Authorization: `Bearer ${access_token}`, "Content-Type": "application/json" },
  });

export const runExportService = (access_token, exportId) =>
  axios.post(`${api}/Export/RunExport?exportId=${exportId}`, null, {
    headers: { Authorization: `Bearer ${access_token}` },
  });

export const downloadExportService = (access_token, exportId) =>
  axios.get(`${api}/Export/DownloadExport?exportId=${exportId}`, {
    headers: { Authorization: `Bearer ${access_token}` },
    responseType: "blob",
  });

export const fetchPatientsBySiteService = (access_token, siteId) =>
  axios.get(`${api}/Export/GetPatientsBySite${siteId ? `?siteId=${siteId}` : ""}`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
